import {logger} from 'yougile-util'
import {GenericSocket, GenReq, SocketState} from 'yougile-model'
import {websocketState} from './client-socket'

export class NativeClientSocket implements GenericSocket {
  private listeners: Map<string, (message: GenReq) => void> = new Map()
  private allListeners?: (type: string, message: GenReq) => void
  private socket: WebSocket

  constructor(url: string, onOpen: () => void) {
    this.socket = new WebSocket(url)
    this.socket.addEventListener('open', onOpen)
    this.socket.addEventListener('message', e => {
      const rawData = e.data
      try {
        const [type, req] = JSON.parse(rawData) as [string, GenReq]
        this.listeners.get(type)?.(req)
        if (this.allListeners) {
          this.allListeners(type, req)
        }
      } catch (e) {
        logger.warn(e)
      }
    })
  }

  onError(cb: (e: unknown) => void): void {
    this.socket.addEventListener('error', cb)
  }

  isReady(): boolean {
    return this.state() === 'open'
  }

  onClose(cb: () => void): void {
    this.socket.addEventListener('close', cb)
    this.socket.addEventListener('error', cb)
  }

  state(): SocketState {
    return websocketState(this.socket)
  }

  on<T extends GenReq>(type: string, cb: (message: T) => void): void {
    if (this.listeners.has(type)) {
      logger.error('Listener already set', type)
    } else {
      this.listeners.set(type, cb)
    }
  }

  onAll(cb: (type: string, message: GenReq) => void): void {
    if (this.allListeners) {
      logger.error('Listener already set')
    }
    this.allListeners = cb
  }

  emit(type: string, data: GenReq): void {
    this.socket.send(JSON.stringify([type, data]))
  }

  disconnect(): void {
    this.socket.close()
  }
}
